declare global {
  interface Window {
    site?: 'zuivelengezondheid' | 'nzo'
  }
}

export type SiteKind = 'ZEG' | 'NZO'

export const getSite = (): SiteKind => {
  switch (window.site) {
    case 'zuivelengezondheid':
      return 'ZEG'
    case 'nzo':
    default:
      return 'NZO'
  }
}
